<template>
  <div class="home">
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span>日程列表</span>
        <el-button
          style="float: right;"
          type="primary"
          @click="$router.push({name:'edit'})"
        >添加每日菜式</el-button>
      </div>
      <el-row
        type="flex"
        class="row-bg"
        justify="space-between"
      >
        <el-col :span="3">
          <div class="col">就餐时间</div>
        </el-col>
        <el-col :span="18">
          <div class="col">菜品</div>
        </el-col>
        <el-col :span="7">
          <div class="col">操作</div>
        </el-col>
      </el-row>
    <div>
      <template v-for="(tableData,index) in tableDataList">
        <el-table
          border
          :data="tableData"
          :key="index"
          style="width: 100%"
        >
          <el-table-column
            label="就餐时间"
            prop="meal_type"
          >
            <template slot="header">
              <span>{{dateList[index]}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="午餐"
            prop="lunch"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.lunch">{{scope.row.lunch.A}}</div>
              <div v-if="scope.row.lunch">{{scope.row.lunch.B}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="晚餐"
            prop="dinner"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.dinner">{{scope.row.dinner.A}}</div>
              <div v-if="scope.row.dinner">{{scope.row.dinner.B}}</div>
            </template>
          </el-table-column>
          <el-table-column align="right">
            <template slot="header">
              <el-button
                @click="$router.push({name:'edit',params:{date:dateList[index]}})"
                type="primary"
              >编辑</el-button>
              <el-button
                type="primary"
                @click="handleDelete(dateList[index])"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[2, 3,5, 10]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      dateList: [],
      ids: [],
      tableDataList: [],
      currentPage: 1,
      total: 0,
      limit: 2
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.tableDataList = []
      this.ids = []
      this.dateList = []
      this.$http.get('/api/meal/index', {
        params: {
          page: this.currentPage,
          limit: this.limit
        }
      }).then(res => {
        this.total = res.data.data.count
        this.formatterData(res.data.data.list)
      })
    },
    handleDelete(date) {
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await this.confirmDelete(date);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
    confirmDelete (date) {
      this.$http.post('/api/meal/delete', { date }).then(res => {
        res = res.data
        if (res.status == 200) {
          this.$message({
            message: res.msg || '操作成功',
            type: 'success',
          });
          this.$router.go(0);
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      }
      )
    },
    handleSizeChange (newSize) {
      this.limit = newSize
      this.getData()
    },
    handleCurrentChange (newPage) {
      this.currentPage = newPage
      this.getData()
    },
    formatterData (data) {
      data.forEach(item => {
        // 存每天菜单id
        this.ids.push(item.id)
        // 存该菜单的日期
        const date = new Date(item.riqi * 1000)
        this.dateList.push(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate())
        const caiItem = []
        item.list.forEach(eat => {
          const periodType = this.judgePeriod(eat.period)
          const type = this.judgeType(eat.type).toUpperCase()
          const mealType = this.judgeMealType(eat.meal_type)
          const index = this.judgeArrayHasCai(mealType, caiItem)
          if (index !== -1) {
            if (!Object.prototype.hasOwnProperty.call(caiItem[index], periodType)) {
              caiItem[index][periodType] = {}
            }
            caiItem[index][periodType][type] = `${type}餐: ${eat.simple}`
          } else {
            const cai = { meal_type: mealType }
            cai[periodType] = {}
            cai[periodType][type] = {}
            cai[periodType][type] = `${type}餐: ${eat.simple}`
            caiItem.push(cai)
          }
        })
        this.tableDataList.push(caiItem)
      })
    },
    judgeMealType (mealType) {
      let type
      switch (mealType) {
        case 1:
          type = '普通餐'
          break
        case 2:
          type = '行政餐'
          break
        case 3:
          type = '幼儿餐'
          break
        case 4:
          type = '学生餐'
          break
        case 5:
          type = '活动餐'
          break
      }
      return type
    },
    judgePeriod (period) {
      return period === 1 ? 'lunch' : 'dinner'
    },
    judgeType (type) {
      return type === 1 ? 'a' : 'b'
    },
    judgeArrayHasCai (meal_type, array) {
      let index = -1
      for (var i = 0; i < array.length; i++) {
        if (array[i].meal_type === meal_type) {
          index = i
        }
      }
      return index
    }
  }
}
</script>

<style>
.home{
  margin: 20px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}
.el-table {
  margin-bottom: 20px;
}
.pagination-box {
  position: relative;
}
.el-pagination {
  position: absolute;
  right: 20px;
  top: 0;
}
.total-count {
  min-height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
